import styles from "./styles/TemplatesGrid.module.css";
import React, { Children, useEffect, useState } from "react";
import { useItemsFine, useSingleItem } from "../actions/app/items";
import SingleTemplateItem from "./SingleTemplateItem";
import PreviewTemplate from "../qmade/creator/PreviewTemplate";
import TemplateEditDialog from "./TemplateEditDialog";
import startCase from "lodash/startCase";
import { Button, Checkbox, Form, Pagination, Space, Tabs } from "antd";
import RelationFieldStanard from "../qforms/standard_elements/RelationFieldStandard";
import { useHistory, useLocation } from "react-router-dom";
import log from "cslog";
import json from "react-syntax-highlighter/dist/esm/languages/prism/json";
import { PreviewTemplateList } from "../qmade/creator/PreviewTemplateList";
import MyCreations from "../creations/MyCreations";
import PresetSuggestions from "../preset_manager/PresetSuggestions";

import {
    EditOutlined,
    EyeOutlined,
    LockOutlined,
    UnlockOutlined,
    BulbOutlined,
} from "@ant-design/icons";
import { atom, useAtom } from "jotai";
import { history } from "../_helpers/history";

const TEMPLATE_FIELDS =
    "id,type,title,status,branding_type,preview.id,preview.filename_disk,tags.id,tags.qdb_tag_id.*,inputs,used_schemas.id,used_schemas.qdb_creation_schema_id.id,used_schemas.qdb_creation_schema_id.name,used_schemas.qdb_creation_schema_id.user_prompt_question,used_schemas.qdb_creation_schema_id.inputs,creation,primary_tags.qdb_tag_id";

const CREATION_FIELDS = `fields=id,title,slug,type,creation_type.name,preview,date_updated,templates,collaborators.*,organization,inputs,used_schemas.qdb_creation_schema_id.id,used_schemas.qdb_creation_schema_id.name,used_schemas.qdb_creation_schema_id.user_prompt_question,used_schemas.qdb_creation_schema_id.inputs,used_schemas.qdb_creation_schema_id.examples&sort=-date_updated`;
const FESTIVAL_PRESET_ID = "0e0c5b74-e8d5-4237-be1e-8e4ae3dded98";
const per_page = 50;

const presetAtom = atom(null);

function TemplatesGrid({ me, isMobile, status }) {
    const history = useHistory();
    const location = useLocation();
    const [total, setTotal] = useState(1);
    const [num_page, setNumPage] = useState(1);
    const [page_no, setPageNo] = useState(1);

    const pathParts = location.pathname.split("/");
    const presetFromUrl = pathParts[pathParts.length - 1]; // Get last part of path
    const [preset, setPreset] = useState(
        presetFromUrl &&
            presetFromUrl !== "templates-manager" &&
            presetFromUrl !== "design-admin"
            ? presetFromUrl
            : null,
    );
    const [activeTab, setActiveTab] = useState("creation");

    // const [preset_full, setPresetFull] = useState(null);
    const [preset_full, setPresetFull] = useAtom(presetAtom);

    const [without_primary_tag, setWithoutPrimaryTag] = useState(false);

    const {
        isSuccess: templateSuccess,
        isLoading: templateLoading,
        data: templateData,
    } = useItemsFine(
        "qdb_creation_template",
        // `fields=${FIELDS}&sort=-date_created&meta=filter_count&limit=${per_page}&offset=${per_page * (page_no - 1)}
        // ${preset ? `&filter[used_schemas][qdb_creation_schema_id][id][_eq]=${preset_full?.origin_preset || preset}` : ""}
        // ${preset_full?.allowed_types?.length > 0 ? `&filter[types][qdb_creation_type_id][_in]=[${preset_full?.allowed_types.map(item => item?.qdb_creation_type_id).join(",")}]` : ""}
        // ${preset === FESTIVAL_PRESET_ID ? (without_primary_tag ? `&filter[count(primary_tags)][_eq]=0` : "&filter[count(primary_tags)][_gt]=0") : ""}`,
        `fields=${TEMPLATE_FIELDS}&sort=-date_created&meta=filter_count&limit=${per_page}&offset=${
            per_page * (page_no - 1)
        }${
            preset
                ? `&filter[used_schemas][qdb_creation_schema_id][id][_eq]=${
                      preset_full?.origin_preset || preset
                  }`
                : ""
        }${
            preset === FESTIVAL_PRESET_ID
                ? without_primary_tag
                    ? `&filter[count(primary_tags)][_eq]=0`
                    : "&filter[count(primary_tags)][_gt]=0"
                : ""
        }`,
        // `fields=${FIELDS}&sort=-date_created&meta=filter_count&limit=${per_page}&offset=${per_page * (page_no - 1)}${preset ? `&filter[used_schemas][qdb_creation_schema_id][id][_eq]=${preset}` : ""}${preset === FESTIVAL_PRESET_ID ? (without_primary_tag ? `&filter[count(primary_tags)][_eq]=0` : "&filter[count(primary_tags)][_gt]=0") : ""}`,
        activeTab === "template",
        false,
        true,
    );

    const {
        isSuccess: creationSuccess,
        isLoading: creationLoading,
        data: creationData,
    } = useItemsFine(
        "qp_creation",
        `fields=${CREATION_FIELDS}&sort=-date_created&meta=filter_count&limit=${per_page}&offset=${
            per_page * (page_no - 1)
        }${
            preset
                ? `&filter[used_schemas][qdb_creation_schema_id][id][_eq]=${
                      preset_full?.origin_preset || preset
                  }`
                : ""
        }`,
        activeTab === "creation",
        false,
        true,
    );

    const [selected_template, setSelectedTemplate] = React.useState(null);
    const [selected_item, setSelectedItem] = React.useState(null);

    const [edit_template, setEditTemplate] = useState(null);

    const isSuccess =
        activeTab === "template" ? templateSuccess : creationSuccess;
    const isLoading =
        activeTab === "template" ? templateLoading : creationLoading;
    const data = activeTab === "template" ? templateData : creationData;

    useEffect(() => {
        setPageNo(1);
    }, [status]);

    useEffect(() => {
        if (isSuccess) {
            const total_records = data?.meta?.filter_count;
            if (total_records > 0) {
                setTotal(total_records);
                setNumPage(Math.ceil(total_records / per_page));
            }
            console.log("User Response", data);
        }
    }, [isSuccess, data]);

    useEffect(() => {
        const pathParts = location.pathname.split("/");
        const urlPreset = pathParts[pathParts.length - 1];

        if (
            urlPreset &&
            urlPreset !== "templates-manager" &&
            urlPreset !== "design-admin"
        ) {
            setPreset(urlPreset);
        } else {
            setPreset(null);
        }
    }, [location.pathname]);

    const updatePresetInUrl = (newPreset) => {
        if (newPreset) {
            history.replace(`/design-admin/templates-manager/${newPreset}`);
        } else {
            history.replace("/design-admin/templates-manager");
        }
    };

    const tabItems = [
        {
            key: "creation",
            label: "Creations",
            children: (
                <MyCreations
                    type="all_creation"
                    me={me}
                    user="all"
                    initial_preset={preset}
                    show_folder_bar={false}
                    show_preset_filter={false}
                    show_create_option={false}
                />
            ),
        },
        {
            key: "template",
            label: "Templates",
            children: (
                <TemplatesView
                    preset={preset}
                    setSelectedTemplate={setSelectedTemplate}
                    selected_template={selected_template}
                    setEditTemplate={setEditTemplate}
                    // templateData={templateData}
                    data={data}
                    isLoading={isLoading}
                    isSuccess={isSuccess}
                />
            ),
        },
    ];

    return (
        <div>
            <h3>{startCase(status)} Templates</h3>
            <Form layout="vertical">
                <Form.Item label="Used preset">
                    <RelationFieldStanard
                        // key={render_key}
                        field={{
                            foreign_key_table: "qdb_creation_schema",
                            foreign_key_column: "id",
                            junction_field: "qdb_tag_id",
                            many_table_pk: "id",
                            template: "{{name}}",
                            type: "relationO2M",
                        }}
                        fieldString="&limit=-1&fields=*,allowed_types.*,similar.related_qdb_creation_schema_id.name,similar.name"
                        value={preset}
                        onChange={(val) => {
                            // alert(val);
                            setPreset(val);
                            updatePresetInUrl(val);
                        }}
                        onChangeFull={(full_val) => {
                            setPresetFull(full_val);
                        }}
                        many={false}
                        style={{
                            width: "400px",
                        }}
                        additional_options={[]}
                    />
                </Form.Item>
            </Form>

            {preset && <PresetCard preset={preset} preset_full={preset_full} />}

            {preset === FESTIVAL_PRESET_ID && (
                <Checkbox
                    checked={without_primary_tag}
                    onChange={(e) => {
                        if (e.target.checked) {
                            setWithoutPrimaryTag(true);
                        } else {
                            setWithoutPrimaryTag(false);
                        }
                    }}
                >
                    Without primary tags
                </Checkbox>
            )}

            <Tabs
                activeKey={activeTab}
                onChange={setActiveTab}
                items={tabItems}
                style={{ marginTop: "20px" }}
            />

            {isSuccess && (
                <p style={{ color: "#0000005a" }}>
                    Showing {data?.data?.length} of total count {total}
                    {/* <pre>
                        {" "}
                        template data
                        {JSON.stringify(templateData, null, 2)}
                    </pre>
                    <pre>
                        {" "}
                        creation data
                        {JSON.stringify(creationData, null, 2)}
                    </pre> */}
                </p>
            )}

            {/* {isSuccess && data?.data?.length > 0 && (
                <div className={styles.grid}>
                    {data?.data?.map((item) => {
                        return (
                            <SingleTemplateItem
                                data={item}
                                previewTemplate={() => {
                                    setSelectedTemplate(item);
                                }}
                                editTemplate={() => {
                                    setEditTemplate(item);
                                }}
                                show_primary_tag={preset === FESTIVAL_PRESET_ID}
                            />
                        );
                    })}
                </div>
            )} */}

            <div style={{ height: 20 }}></div>
            {isSuccess && total > per_page && (
                <>
                    <Pagination
                        current={page_no}
                        onChange={(new_page_no) => setPageNo(new_page_no)}
                        total={total}
                        pageSize={per_page}
                        showTitle={false}
                        showSizeChanger={false}
                        showQuickJumper={true}
                    />
                </>
            )}

            {edit_template && (
                <TemplateEditDialog
                    open={true}
                    setOpen={(val) => {
                        if (!val) {
                            setEditTemplate(null);
                        }
                    }}
                    item={edit_template}
                    isMobile={isMobile}
                    me={me}
                />
            )}
        </div>
    );
}

export default TemplatesGrid;

function PresetCard({ preset, preset_full }) {
    const { isSuccess, isLoading, data } = useSingleItem(
        "qdb_creation_schema",
        `/${preset}`,
        preset ? true : false,
    );
    const { isSuccess: successCreations, data: dataCreations } = useItemsFine(
        "qp_creation",
        `filter[used_schemas][qdb_creation_schema_id][_eq]=${preset}&fields=id,is_themeable&meta=filter_count&limit=-1`,
        !!preset,
        false,
        true,
    );
    const { isSuccess: successTemplates, data: dataTemplates } = useItemsFine(
        "qdb_creation_template",
        `filter[used_schemas][qdb_creation_schema_id][_eq]=${preset}&fields=id,is_themeable&sort=-is_themeable&meta=filter_count&limit=-1`,
        !!preset,
        false,
        true,
    );
    const { isSuccess: successLiveCreations, data: dataLiveCreations } =
        useItemsFine(
            "qp_creation",
            `filter[used_schemas][qdb_creation_schema_id][_eq]=${preset}&filter[is_live][_eq]=true&fields=id&meta=filter_count&limit=0`,
            !!preset,
            false,
            true,
        );

    if (isLoading) {
        <p>Loading...</p>;
    }

    if (!isSuccess) {
        return <></>;
    }

    log.d(preset_full, "preset full in TGG");
    log.d(dataTemplates, "data templates in preset card");
    const themeableTemplatesCount =
        successTemplates && Array.isArray(dataTemplates?.data)
            ? dataTemplates.data.filter((item) => item?.is_themeable).length
            : null;
    const themeableCreationsCount =
        successCreations && Array.isArray(dataCreations?.data)
            ? dataCreations.data.filter((item) => item?.is_themeable).length
            : null;

    const totalCreations = dataCreations?.meta?.filter_count ?? 0;
    const totalTemplates = dataTemplates?.meta?.filter_count ?? 0;
    const totalLive = dataLiveCreations?.meta?.filter_count ?? 0;

    const statTiles = [
        {
            label: "Creations",
            value: successCreations ? totalCreations : null,
            sub: successCreations
                ? `${themeableCreationsCount ?? 0} themeable`
                : null,
            accent: "#6366f1",
            icon: "🎨",
        },
        {
            label: "Templates",
            value: successTemplates ? totalTemplates : null,
            sub: successTemplates
                ? `${themeableTemplatesCount ?? 0} themeable`
                : null,
            accent: "#0ea5e9",
            icon: "📐",
        },
        {
            label: "Live",
            value: successLiveCreations ? totalLive : null,
            sub:
                successLiveCreations && totalCreations > 0
                    ? `${Math.round((totalLive / totalCreations) * 100)}% of creations`
                    : null,
            accent: "#10b981",
            icon: "🟢",
        },
    ];

    return (
        <div
            style={{
                background: "#ffffff",
                borderRadius: "14px",
                padding: "20px 24px",
                marginBottom: "20px",
                boxShadow:
                    "0 1px 4px rgba(0,0,0,0.08), 0 4px 16px rgba(0,0,0,0.06)",
                border: "1px solid #e2e8f0",
                color: "#1e293b",
                position: "relative",
                overflow: "hidden",
            }}
        >
            {/* decorative glow */}
            <div
                style={{
                    position: "absolute",
                    top: -40,
                    right: -40,
                    width: 160,
                    height: 160,
                    borderRadius: "50%",
                    background:
                        "radial-gradient(circle, rgba(99,102,241,0.08) 0%, transparent 70%)",
                    pointerEvents: "none",
                }}
            />

            {/* Header row */}
            <div
                style={{
                    display: "flex",
                    alignItems: "flex-start",
                    justifyContent: "space-between",
                    marginBottom: "18px",
                    flexWrap: "wrap",
                    gap: "10px",
                }}
            >
                <div>
                    <div
                        style={{
                            fontSize: "11px",
                            fontWeight: 600,
                            letterSpacing: "0.1em",
                            textTransform: "uppercase",
                            color: "#94a3b8",
                            marginBottom: "4px",
                        }}
                    >
                        Preset Schema
                    </div>
                    <div
                        style={{
                            fontSize: "20px",
                            fontWeight: 700,
                            color: "#0f172a",
                            lineHeight: 1.2,
                        }}
                    >
                        {data.name}
                    </div>
                    <div
                        style={{
                            marginTop: "6px",
                            fontSize: "11px",
                            color: "#64748b",
                            fontFamily: "monospace",
                            background: "#f1f5f9",
                            display: "inline-block",
                            padding: "2px 8px",
                            borderRadius: "4px",
                            border: "1px solid #e2e8f0",
                        }}
                    >
                        {data?.id}
                    </div>
                </div>

                {/* Actions */}
                <div
                    style={{
                        display: "flex",
                        gap: "8px",
                        alignItems: "center",
                        flexShrink: 0,
                    }}
                >
                    {preset_full && (
                        <Button
                            onClick={() => {
                                history.push(
                                    `/settings/presets/${preset_full?.id}/edit`,
                                    { from: history.location.pathname },
                                );
                            }}
                            disabled={preset_full?.locked}
                            icon={
                                preset_full?.locked ? (
                                    <LockOutlined />
                                ) : (
                                    <EditOutlined />
                                )
                            }
                            style={{
                                background: "#f8fafc",
                                border: "1px solid #cbd5e1",
                                color: preset_full?.locked
                                    ? "#94a3b8"
                                    : "#475569",
                                borderRadius: "8px",
                            }}
                        >
                            {!preset_full?.locked && "Edit"}
                        </Button>
                    )}
                    <PresetSuggestions
                        record={preset_full}
                        trigger={
                            <Button
                                icon={<BulbOutlined />}
                                style={{
                                    background: "#eef2ff",
                                    border: "1px solid #c7d2fe",
                                    color: "#4f46e5",
                                    borderRadius: "8px",
                                }}
                            >
                                Suggestions
                            </Button>
                        }
                    />
                </div>
            </div>

            {/* Stat tiles */}
            <div
                style={{
                    display: "grid",
                    gridTemplateColumns: "repeat(3, 1fr)",
                    gap: "12px",
                }}
            >
                {statTiles.map((tile) => (
                    <div
                        key={tile.label}
                        style={{
                            background: "#f8fafc",
                            borderRadius: "10px",
                            padding: "14px 16px",
                            border: `1px solid ${tile.accent}25`,
                            position: "relative",
                            overflow: "hidden",
                        }}
                    >
                        <div
                            style={{
                                position: "absolute",
                                top: 0,
                                left: 0,
                                right: 0,
                                height: "3px",
                                background: tile.accent,
                                borderRadius: "10px 10px 0 0",
                            }}
                        />
                        <div
                            style={{
                                display: "flex",
                                alignItems: "center",
                                gap: "6px",
                                marginBottom: "8px",
                            }}
                        >
                            <span style={{ fontSize: "14px" }}>
                                {tile.icon}
                            </span>
                            <span
                                style={{
                                    fontSize: "11px",
                                    fontWeight: 600,
                                    color: "#94a3b8",
                                    textTransform: "uppercase",
                                    letterSpacing: "0.08em",
                                }}
                            >
                                {tile.label}
                            </span>
                        </div>
                        {tile.value === null ? (
                            <div
                                style={{
                                    height: "28px",
                                    background: "#e2e8f0",
                                    borderRadius: "4px",
                                    opacity: 0.6,
                                }}
                            />
                        ) : (
                            <>
                                <div
                                    style={{
                                        fontSize: "28px",
                                        fontWeight: 800,
                                        color: "#0f172a",
                                        lineHeight: 1,
                                    }}
                                >
                                    {tile.value}
                                </div>
                                {tile.sub && (
                                    <div
                                        style={{
                                            fontSize: "11px",
                                            color: tile.accent,
                                            marginTop: "4px",
                                            fontWeight: 500,
                                        }}
                                    >
                                        {tile.sub}
                                    </div>
                                )}
                            </>
                        )}
                    </div>
                ))}
            </div>
        </div>
    );
}

function TemplatesView({
    preset,
    setSelectedTemplate,
    selected_template,
    me,
    isMobile,
    setEditTemplate,
    data,
    isSuccess,
    isLoading,
}) {
    if (isLoading) {
        <p>Loading...</p>;
    }

    if (!isSuccess) {
        return <></>;
    }
    return (
        <>
            {isSuccess && (
                <p style={{ color: "#0000005a" }}>
                    Showing {data?.data?.length} of total count{" "}
                    {data?.meta?.filter_count}
                </p>
            )}
            {isSuccess && data?.data?.length > 0 && (
                <div className={styles.grid}>
                    {data?.data?.map((item) => {
                        return (
                            <SingleTemplateItem
                                data={item}
                                previewTemplate={() => {
                                    setSelectedTemplate(item);
                                }}
                                editTemplate={() => {
                                    setEditTemplate(item);
                                }}
                                show_primary_tag={preset === FESTIVAL_PRESET_ID}
                            />
                        );
                    })}
                </div>
            )}

            {selected_template && (
                <PreviewTemplate
                    open={true}
                    setOpen={(val) => {
                        if (!val) {
                            setSelectedTemplate(null);
                        }
                    }}
                    is_template={true}
                    slug_field="id"
                    isMobile={isMobile}
                    item={selected_template}
                    enable_nav={false}
                    me={me}
                    preset={preset}
                />
            )}
        </>
    );
}

function CreationsView({
    preset,
    setSelectedItem,
    selected_item,
    setEditTemplate,
    data,
    isSuccess,
    isLoading,
    isMobile,
    me,
}) {
    if (isLoading) {
        <p>Loading...</p>;
    }

    if (!isSuccess) {
        return <></>;
    }

    return (
        <>
            {isSuccess && (
                <p style={{ color: "#0000005a" }}>
                    Showing {data?.data?.length} of totallll count{" "}
                    {data?.meta?.filter_count}
                </p>
            )}
            {isSuccess && data?.data?.length > 0 && (
                <div className={styles.grid}>
                    {data?.data?.map((item) => {
                        return (
                            <SingleTemplateItem
                                data={item}
                                previewTemplate={() => {
                                    setSelectedItem(item);
                                }}
                                // editTemplate={() => {
                                //     setEditTemplate(item);
                                // }}
                                show_primary_tag={preset === FESTIVAL_PRESET_ID}
                            />
                        );
                    })}
                </div>
            )}
            {selected_item && (
                <PreviewTemplate
                    item={selected_item}
                    open={true}
                    setOpen={(val) => {
                        if (!val) {
                            setSelectedItem(null);
                        }
                    }}
                    is_template={false}
                    slug_field="slug"
                    enable_img_preview={false}
                    me={me}
                    isMobile={isMobile}
                    preset={preset}
                />
            )}
        </>
    );
}
